import { render, staticRenderFns } from "./ChooseProduct.vue?vue&type=template&id=2ba1fd48&scoped=true"
import script from "./ChooseProduct.vue?vue&type=script&lang=js"
export * from "./ChooseProduct.vue?vue&type=script&lang=js"
import style0 from "./ChooseProduct.vue?vue&type=style&index=0&id=2ba1fd48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1fd48",
  null
  
)

export default component.exports